export default __webpack_public_path__ + "static/media/search.b1f781b9.svg";